import { useQuery } from "@tanstack/react-query";
import { apiService } from "@/lib/api";
import { useMemo } from "react";

// 24 hours stale time for catalog data
const CATALOG_STALE_TIME = 1000 * 60 * 60 * 24;

export const useBloodGlucoseSourceTypes = () => {
  const {
    data: sourceTypes = [],
    isLoading: loading,
    error: queryError,
    refetch,
  } = useQuery({
    queryKey: ["bloodGlucoseSourceTypes"],
    queryFn: async () => {
      const response = await apiService.getBloodGlucoseSourceTypes();
      return response.data;
    },
    staleTime: CATALOG_STALE_TIME,
    gcTime: CATALOG_STALE_TIME, // Keep in cache for 24h
  });

  const error = queryError
    ? (queryError as Error).message ||
      "Failed to fetch blood glucose source types"
    : null;

  // Get unique grouped_as values
  const groupedAsOptions = useMemo((): { value: string; label: string }[] => {
    const uniqueGroups: string[] = [
      ...new Set(
        sourceTypes.map((type: { grouped_as: string }) => type.grouped_as)
      ),
    ] as string[];
    return uniqueGroups.map((group) => ({
      value: group,
      label: group.charAt(0).toUpperCase() + group.slice(1).replace("_", " "),
    }));
  }, [sourceTypes]);

  // Get items by group
  const getItemsByGroup = (groupedAs: string) => {
    return sourceTypes.filter((type) => type.grouped_as === groupedAs);
  };

  return {
    sourceTypes,
    loading,
    error,
    groupedAsOptions,
    getItemsByGroup,
    refetch,
  };
};
